import { Component, HostListener, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Device } from 'src/app/core/models/device.model';
import { Pagination, PaginationRequest } from 'src/app/core/models/pagination.model';
import { DeviceService } from 'src/app/core/services/device.service';
import { User } from 'src/app/core/models/user.model';
import * as utils from 'src/app/shared/helpers/utils';
import { DdbbUtils } from 'src/app/shared/helpers/utils';
import { ConfigService } from 'src/app/core/services/config.service';
import { Entity } from 'src/app/core/models/entity.model';

@Component({
  selector: 'hbo-device-list',
  templateUrl: './device-list.component.html',
  styleUrls: ['./device-list.component.scss']
})
export class DeviceListComponent implements OnInit {

  @HostListener('document:shown.bs.collapse', ['$event'])
  onAccordionOpen(event: any) {
    this.openedRow = event.target!.id;
  }

  @HostListener('document:hide.bs.collapse', ['$event'])
  onAccordionClosed(event: Event) {
    this.openedRow = null;
  }

  openedRow!: string | null;

  devices$ = new Observable<Pagination<Device>>;
  devicesCollection$: Device[] = [];

  user: User = utils?.localStorageGetItem('user');

  columns!: string[];

  constructor(
    private configSvc: ConfigService,
    private ddbbUtils: DdbbUtils,
    private deviceService: DeviceService
  ) {
    this.user.childEntities = this.configSvc.currentConfigValue.childEntities
  }

  get teams() {
    return this.configSvc.currentConfigValue.teams ?? [];
  }

  ngOnInit() {
    if (this.user.roleId === 1) {
      this.columns = ['id', 'type', 'snMac', 'entity', 'entityParent', 'linked', 'hardwareVersion', 'frontendSwVersion', 'backendSwVersion', 'lastActivity', 'appName'];
    } else if (this.user.roleId === 2 || this.user.roleId === 3) {
      this.columns = ['type', 'snMac', 'entity', 'entityParent', 'linked', 'hardwareVersion', 'frontendSwVersion', 'backendSwVersion', 'lastActivity'];
    } else {
      this.columns = ['type', 'snMac', 'entity', 'entityParent', 'linked'];
    }
    
    // Read pagination from config service or localStorage
    this.configSvc.currentConfigValue['devices']?.pagination
      ? this.searchDevices(this.configSvc.currentConfigValue['devices'].pagination)
      : null;
    const storageDevicesFilter = localStorage.getItem('devicesFilter');
    if (storageDevicesFilter) {
      const parsedFilter = JSON.parse(storageDevicesFilter) as PaginationRequest;
      // Parse filter_params if it's a string
      if (parsedFilter.filter_params && typeof parsedFilter.filter_params === 'string') {
        parsedFilter.filter_params = JSON.parse(parsedFilter.filter_params as unknown as string);
      }
      this.configSvc.setConfigPaginationParamValue('devices', 'pagination', parsedFilter);
      this.searchDevices(parsedFilter);
    } else {
      this.searchDevices();
    }
  }

  searchDevices(pagination?: PaginationRequest) {
    this.openedRow = null;
    let entities: string | null = null;
    if (this.configSvc.currentConfigValue.devicesListSelected?.length) {
      entities = `${this.configSvc.currentConfigValue.devicesListSelected?.map((entity: Entity) => entity.id).join(',')}`;
    }
    
    // Keep original filter_params as object
    const originalFilterParams = pagination?.filter_params;
    
    // Create a copy for API call with stringified filter_params
    let apiPagination = pagination;
    if (pagination) {
      pagination.entities = entities;
      // Stringify filter_params if it's an object for API request
      if (pagination.filter_params && typeof pagination.filter_params !== 'string') {
        apiPagination = { ...pagination, filter_params: JSON.stringify(pagination.filter_params) as any };
      }
    }
    
    this.devices$ = this.deviceService.index(apiPagination ?? { order: 'desc', entities: entities }).pipe(
      tap(result => {
        this.devicesCollection$ = result.data;
        // Restore original filter_params as object (API doesn't return it)
        if (originalFilterParams) {
          result.filter_params = originalFilterParams;
        }
      })
    );
  }

  refresh() {
    this.searchDevices();
  }



  callback = (e: any) => {
    switch (e.action) {
      case 'updated':
        const propsToRemove = [];
        this.devicesCollection$.map((device: Device) => {
          if (device.id === e.result.id) { this.deepMerge(device, e.result) };
        })
        break;
      default:
        break;
    }
  }

  deepMerge = (target: any, source: any) => {
    for (const key in source) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key])
      ) {
        if (!target[key] || typeof target[key] !== 'object') {
          target[key] = {};
        }
        this.deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }

  packagesLinks = (_packages:string) =>{
    // console.log(_packages);
      return _packages.split(',')
  }


}
